<template>
  <div class="ai-task">
    <ai-execution-state v-if="processing" :status="card.executionStatus" :read-only="readOnly" :progress="true" :label="card.title" />
    <p v-else class="task-title">{{ card.title }}</p>
  </div>
</template>
<script>
import behavior from '@/ai/components/mixins/card-behavior'
import AiExecutionState from './AiExecutionState.vue'
export default {
  mixins: [behavior],
  components: { AiExecutionState },
  computed: {
    // 服务端新回复只用task表示进度；旧终态卡片仅展示原文，不追加徽标或解释。
    processing() { return ['NOT_STARTED', 'DISPATCHING'].includes(this.card.executionStatus) }
  }
}
</script>
<style scoped>
.ai-task { min-width:0; }
.task-title { margin:4px 0 0;font-size:14px;line-height:1.6;color:#344154;overflow-wrap:anywhere; }
</style>
